import React, { useEffect, useReducer } from 'react';

// REDUX
import { useAppSelector } from '@Managers/Redux/Hooks';
import { getFixesState } from '@Managers/Redux/AppState/AppState';

// STYLES
import FixesSimpleSelector from './Fixes.simpleSelector';
import FixesExtendedSelector from './extended/Fixes.extendedSelector';

const FixesSelector: React.FC<{}> = ({}) => {
    const [state, setState] = useReducer((state: { extendView: boolean }, newState: {}) => ({ ...state, ...newState }), {
        extendView: false
    });

    const fixesState = useAppSelector(getFixesState);

    useEffect(() => {
        setState({ extendView: fixesState.extendedSelector });
    }, [fixesState]);

    return <>{!state.extendView ? <FixesSimpleSelector /> : <FixesExtendedSelector />}</>;
};

export default FixesSelector;
